import React, { useContext, useEffect, useState } from 'react'
import { SiteContext } from '../site/siteContext'
import { Icon } from './icon'
import { Text } from './text'
import './textfield-outlined.css'
import './textfield.css'
import './textarea.css'

/**
 * Text Field
 */
export const TextField = (props) => {

    const site = useContext(SiteContext)
    const { id, type = 'text', label, placeholder, value, outlined, readOnly = false, canClear = true, onChange, onEnter, onClick, onBlur } = props

    function onKeyPress(event) {
        var key = event.charCode ? event.charCode : event.keyCode ? event.keyCode : 0;
        if (key == 13) {
            if (onEnter) onEnter()
        }
    }

    function change(event) {
        event.stopPropagation()
        event.preventDefault()
        const value = event.target.value
        if (onChange) onChange(id, value)
    }

    function focus() {
        if (site && site.changeFocus) {
            site.changeFocus({
                lose: () => {
                    // DO NOTHING
                }
            })
        }
    }

    function blur() {
        if (onBlur) onBlur()
    }

    function clear() {
        if (onChange) onChange(id, "")
    }

    const borderStyle = outlined ? "textfield-outlined" : "textfield"
    const labelStyle = label ? "" : "no-label"
    const style = `${labelStyle} ${borderStyle} textfield-${type}`
    const labelTxt = <Text>{label}</Text>

    return (
        <div className={`${style}`} onClick={onClick}>
            <input id={id} type={type} placeholder={placeholder} value={value} required onChange={change} onKeyDown={onKeyPress} onFocus={focus} onBlur={blur} readOnly={readOnly} />
            {canClear && value && value.length > 0 ? <Icon icon="close" clickable size="small" action={clear} /> : null}
            <span className="bar"></span>
            {label ? <label>{labelTxt}</label> : null}
        </div>
    )
}


/**
 * Text Area
 */
export const TextArea = (props) => {

    const site = useContext(SiteContext)
    const { id, type = 'text', label, placeholder, value, outlined, readOnly = false, canClear = true, onChange, onEnter, onClick } = props

    function onKeyPress(event) {
        var key = event.charCode ? event.charCode : event.keyCode ? event.keyCode : 0;
        if (key == 13) {
            if (onEnter) onEnter()
        }
    }

    function change(event) {
        event.stopPropagation()
        event.preventDefault()
        const value = event.target.value
        if (onChange) onChange(id, value)
    }

    function focus() {
        if (site && site.changeFocus) {
            site.changeFocus({
                lose: () => {
                    // DO NOTHING
                }
            })
        }
    }

    function clear() {
        if (onChange) onChange(id, "")
    }

    const labelStyle = label ? "" : "no-label"
    const style = `textarea ${labelStyle} textarea-${type}`
    const labelTxt = <Text>{label}</Text>

    return (
        <div className={`${style}`} onClick={onClick}>
            <textarea id={id} placeholder={placeholder} value={value} required onChange={change} onKeyDown={onKeyPress} onFocus={focus} readOnly={readOnly} />
            {canClear && value && value.length > 0 ? <Icon icon="close" clickable size="small" action={clear} /> : null}
            <span className="bar"></span>
            {label ? <label>{labelTxt}</label> : null}
        </div>
    )
}


/**
 * Dropdown
 */
export const DropDown = (props) => {

    const site = useContext(SiteContext)
    const { id, options = [], value, onChange, predictive = false, readOnly = false, verbose = true, onBlur } = props
    const [open, setOpen] = useState(false)
    const [label, setLabel] = useState()

    useEffect(() => {
        console.log('DD change value', label)
        if (Array.isArray(options)) {
            const option = options.find(option => option.value === value)
            const label = option ? option.label : ""
            setLabel(label)
        }
    }, [value])

    function change(id, value) {
        if (predictive) {
            setLabel(value)
        } else {
            if (onChange) onChange(id, value)
        }
    }

    function toggle() {
        if (site && site.changeFocus) {
            site.changeFocus({
                lose: () => {
                    setOpen(false)
                }
            })
        }
        if (!readOnly) setOpen(!open)
    }

    function select(event) {
        const next = event.target.getAttribute("value")
        const option = options.find(option => option.value === next)
        setOpen(false)
        const label = verbose ? option.label : ""
        setLabel(label)
        if (onChange) onChange(id, next)
    }

    function blur() {
        if (onBlur) onBlur()
    }

    function renderOptions() {
        const canShow = open == true && Array.isArray(options)
        if (canShow) {
            const filterActive = predictive === true && label && label.length > 0
            const items = filterActive ? options.filter(option => option.label.toUpperCase().indexOf(label.toUpperCase()) >= 0) : options
            const lis = items.map(option => <li key={option.value} value={option.value}>{option.label}</li>)
            return <menu><ul onMouseDown={select}>{lis}</ul></menu>
        } else {
            return null
        }
    }

    return (
        <div className="dropdown">
            <TextField {...props} onClick={toggle} value={label} onChange={change} onBlur={blur} readOnly={!predictive} />
            {!readOnly ? <Icon icon="expand_more" clickable size="small" action={toggle} /> : null}
            {renderOptions()}
        </div>
    )
}
